export default __webpack_public_path__ + "computer-tablet.png";